var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBathtub(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10.588h18l-.452 2.126a4 4 0 01-3.912 3.168H4.364a4 4 0 01-3.912-3.168L0 10.588h0z",
    stroke: "#666",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeLinecap: "round",
    d: "M13.878 15.882L14.71 18"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#666",
    cx: 2.118,
    cy: 4.235,
    r: 1.059
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.594 2.6c.605.932.321 2.203-.622 2.929l-2.307-3.552c1.047-.567 2.324-.309 2.929.623z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.118 10.101l-.082-6.996a2 2 0 00-2.848-1.788l-2.482 1.162h0",
    stroke: "#666"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#666",
    cx: 5.824,
    cy: 6.882,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeLinecap: "round",
    d: "M4.122 15.882L3.29 18"
  })))));
}
export default SvgBathtub;